import { GraphQLClient, RequestDocument } from "graphql-request";
import i18next from "i18next";
import { Locale, Stage } from "../vo/graphCMS";
import { getCountry, isValidCountry, isValidLanguage } from "../../router/scripts/params";
import { devLogInfoOnce } from "../../common/scripts/logger/log";
import { HYGRAPH_ENDPOINT } from "../../common/scripts/config/configuration";

export function getStage(): Stage.Draft | Stage.Published {
  return window.location.href.includes("preview=true") ? Stage.Draft : Stage.Published;
}

function getClient() {
  return new GraphQLClient(HYGRAPH_ENDPOINT, {
    headers: {
      "gcms-stage": getStage(),
      "gcms-locales": `${i18next.resolvedLanguage},${Locale.De}`,
    },
  });
}

// todo: improve return type
export async function graphCMSQuery(query: RequestDocument, variables?: any): Promise<any> {
  try {
    // abort on invalid country
    if (!isValidCountry()) {
      devLogInfoOnce(`aborted graphql request due to invalid country: (${getCountry()})`);
      return;
    }

    // abort on invalid language
    if (!isValidLanguage()) {
      devLogInfoOnce(
        `aborted graphql request due to invalid language: (${i18next.resolvedLanguage})`,
      );
      return;
    }

    return await getClient().request(query, variables);
  } catch (e) {
    console.error(e);
  }
}
